import React from 'react';
import { Link } from 'react-router-dom';

import {
  visa, mastercard, bkash, nagad, rocket,
  bitcoin, tether, etherium, standart,
  gambleaware, gamblingtherapy, logo
} from "../../assets/images";

const paymentLogos = [
  { src: visa, alt: "Visa" },
  { src: mastercard, alt: "Mastercard" },
  { src: bkash, alt: "bKash" },
  { src: nagad, alt: "Nagad" },
  { src: rocket, alt: "Rocket" },
  { src: bitcoin, alt: "Bitcoin" },
  { src: tether, alt: "Tether (USDT)" },
  { src: etherium, alt: "Ethereum" },
  { src: standart, alt: "Standard Chartered" },
];

const socialLinks = [
  { href: "https://haruvest.com/W7DZsfpK", icon: <svg xmlns="http://www.w3.org/2000/svg" fill='grey' width={30} height={30} viewBox="0 0 512 512"><path d="M48 64c-26.5 0-48 21.5-48 48 0 15.1 7.1 29.3 19.2 38.4l208 156c17.1 12.8 40.5 12.8 57.6 0l208-156c12.1-9.1 19.2-23.3 19.2-38.4 0-26.5-21.5-48-48-48L48 64zM0 196L0 384c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-188-198.4 148.8c-34.1 25.6-81.1 25.6-115.2 0L0 196z"/></svg> },
  { href: "https://haruvest.com/W7DZsfpK", icon: <svg xmlns="http://www.w3.org/2000/svg" fill='grey' width={30} height={30} viewBox="0 0 448 512"><path d="M224.3 141a115 115 0 1 0 -.6 230 115 115 0 1 0 .6-230zm-.6 40.4a74.6 74.6 0 1 1 .6 149.2 74.6 74.6 0 1 1 -.6-149.2zm93.4-45.1a26.8 26.8 0 1 1 53.6 0 26.8 26.8 0 1 1 -53.6 0zm129.7 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM399 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z"/></svg> },
  { href: "https://haruvest.com/W7DZsfpK", icon: <svg xmlns="http://www.w3.org/2000/svg"  fill='grey' width={30} height={30} viewBox="0 0 448 512"><path d="M357.2 48L427.8 48 273.6 224.2 455 464 313 464 201.7 318.6 74.5 464 3.8 464 168.7 275.5-5.2 48 140.4 48 240.9 180.9 357.2 48zM332.4 421.8l39.1 0-252.4-333.8-42 0 255.3 333.8z"/></svg> },
  { href: "https://haruvest.com/W7DZsfpK", icon: <svg xmlns="http://www.w3.org/2000/svg" fill='grey' width={30} height={30} viewBox="0 0 320 512"><path d="M80 299.3l0 212.7 116 0 0-212.7 86.5 0 18-97.8-104.5 0 0-34.6c0-51.7 20.3-71.5 72.7-71.5 16.3 0 29.4 .4 37 1.2l0-88.7C291.4 4 256.4 0 236.2 0 129.3 0 80 50.5 80 159.4l0 42.1-66 0 0 97.8 66 0z"/></svg> },
  { href: "https://haruvest.com/W7DZsfpK", icon: <svg xmlns="http://www.w3.org/2000/svg" fill='grey' width={30} height={30} viewBox="0 0 512 512"><path d="M256 8a248 248 0 1 0 0 496 248 248 0 1 0 0-496zM371 176.7c-3.7 39.2-19.9 134.4-28.1 178.3-3.5 18.6-10.3 24.8-16.9 25.4-14.4 1.3-25.3-9.5-39.3-18.7-21.8-14.3-34.2-23.2-55.3-37.2-24.5-16.1-8.6-25 5.3-39.5 3.7-3.8 67.1-61.5 68.3-66.7 .2-.7 .3-3.1-1.2-4.4s-3.6-.8-5.1-.5c-2.2 .5-37.1 23.5-104.6 69.1-9.9 6.8-18.9 10.1-26.9 9.9-8.9-.2-25.9-5-38.6-9.1-15.5-5-27.9-7.7-26.8-16.3 .6-4.5 6.7-9 18.4-13.7 72.3-31.5 120.5-52.3 144.6-62.3 68.9-28.6 83.2-33.6 92.5-33.8 2.1 0 6.6 .5 9.6 2.9 2 1.7 3.2 4.1 3.5 6.7 .5 3.2 .6 6.5 .4 9.8z"/></svg> },
  { href: "https://haruvest.com/W7DZsfpK", icon: <svg xmlns="http://www.w3.org/2000/svg" fill='grey' width={30} height={30} viewBox="0 0 448 512"><path d="M380.9 97.1c-41.9-42-97.7-65.1-157-65.1-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480 117.7 449.1c32.4 17.7 68.9 27 106.1 27l.1 0c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3 18.6-68.1-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1s56.2 81.2 56.1 130.5c0 101.8-84.9 184.6-186.6 184.6zM325.1 300.5c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8s-14.3 18-17.6 21.8c-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7 .9-6.9-.5-9.7s-12.5-30.1-17.1-41.2c-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2s-9.7 1.4-14.8 6.9c-5.1 5.6-19.4 19-19.4 46.3s19.9 53.7 22.6 57.4c2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4s4.6-24.1 3.2-26.4c-1.3-2.5-5-3.9-10.5-6.6z"/></svg> },
];

const t = {
  en: {
    home: "Home",
    casino: "Casino",
    slots: "Slots",
    games: "Games",
    bet: "Bet",
    login: "Login",
    app: "App",
    bonuses: "Bonuses",
    aviator: "Aviator",
    crazy: "Crazy Time",
    age: "You must be at least 18 years old to create an account. We do not allow underage users.",
    closingTitle: "HHBD – The Top Choice for Elite Online Gaming!",
    closing1: "Step into the thrilling universe of HHBD, where every spin, bet, and win delivers premium entertainment. Explore a rich library of high-quality games, unlock special bonuses, and play on a fully secure platform built for serious players.",
    closing2: "Register with HHBD now and begin your path to real rewards. Every session promises excitement, control, and a chance to win big!"
  },
  bn: {
    home: "হোম",
    casino: "ক্যাসিনো",
    slots: "স্লট",
    games: "গেমস",
    bet: "বেট",
    login: "লগইন",
    app: "অ্যাপ",
    bonuses: "বোনাস",
    aviator: "অ্যাভিয়েটর",
    crazy: "ক্রেজি টাইম",
    age: "একটি অ্যাকাউন্ট তৈরি করতে আপনার অন্তত ১৮ বছর বয়স হতে হবে। আমরা কম বয়সীদের অনুমতি দেই না।",
    closingTitle: "৫৫৫আইকিউ – অনলাইন গেমিং এর শীর্ষ পছন্দ!",
    closing1: "৫৫৫আইকিউ-এর উত্তেজনাপূর্ণ জগতে প্রবেশ করুন, যেখানে প্রতিটি স্পিন, বেট এবং জয় এনে দেয় প্রিমিয়াম বিনোদন। বিশাল গেম লাইব্রেরি, বিশেষ বোনাস এবং সর্বোচ্চ নিরাপত্তা পান।",
    closing2: "এখনই নিবন্ধন করুন এবং আসল পুরস্কারের পথে এগিয়ে যান। প্রতিটি সেশন নিয়ে আসে উত্তেজনা, নিয়ন্ত্রণ এবং জয়ের সুযোগ!"
  }
};

const Footer = ({ lang }) => {
  // ✅ Fallback if lang is undefined or invalid
  const currentText = t[lang] || t.en;

  const getLink = (path) => lang === 'bn' ? `/bn${path === '/' ? '' : path}` : path;

  return (
    <footer className="zfooter">
      {/* 1 ▸ top row: logo + quick links */}
      <div className="zfooter__top">
        <Link to={getLink('/')} className="zfooter__logo">
          <img src={logo} alt="HHBD Logo" />
        </Link>

        <nav className="zfooter__nav">
          <ul className="zfooter__links">
            <li><Link to={getLink('/')}>{currentText.home}</Link></li>
            <li><Link to={getLink('/casino')}>{currentText.casino}</Link></li>
            <li><Link to={getLink('/slots')}>{currentText.slots}</Link></li>
            <li><Link to={getLink('/games')}>{currentText.games}</Link></li>
            <li><Link to={getLink('/bet')}>{currentText.bet}</Link></li>
            <li><Link to={getLink('/login')}>{currentText.login}</Link></li>
            <li><Link to={getLink('/app')}>{currentText.app}</Link></li>
            <li><Link to={getLink('/bonuses')}>{currentText.bonuses}</Link></li>
            <li><Link to={getLink('/aviator')}>{currentText.aviator}</Link></li>
            <li><Link to={getLink('/crazy-time')}>{currentText.crazy}</Link></li>
          </ul>
        </nav>
      </div>

      {/* 2 ▸ 18+ + responsible gambling */}
      <div className="zfooter__legal">
        <span className="zfooter__age">
          <i className="fas fa-user-shield"></i> 18+
        </span>
        <p className="zfooter__age-text">{currentText.age}</p>
        <div className="zfooter__care">
          <a href="https://www.gambleaware.org/?cxd=cx-95_365180_lcb" target="_blank" rel="noopener noreferrer">
            <img src={gambleaware} alt="GambleAware" />
          </a>
          <a href="https://gamblingtherapy.org/?cxd=cx-95_365180_lcb" target="_blank" rel="noopener noreferrer">
            <img src={gamblingtherapy} alt="Gambling Therapy" />
          </a>
        </div>
      </div>

      {/* 3 ▸ payment methods */}
      <div className="zfooter__payments">
        {paymentLogos.map((pm, i) => (
          <a href="https://haruvest.com/W7DZsfpK" key={i} rel="noopener noreferrer">
            <img src={pm.src} loading='lazy' width={42} height={42} alt={pm.alt} />
          </a>
        ))}
      </div>
      <hr className="zfooter__divider" />

      {/* 4 ▸ social media */}
      <div className="zfooter__social">
        {socialLinks.map((s, i) => (
          <a href={s.href} key={i}  rel="noopener noreferrer">
            <i >{s.icon}</i>
          </a>
        ))}
      </div>

      {/* 5 ▸ concluding statement */}
      <div className="zfooter__closing">
        <h3 className="zfooter__closing-title">{currentText.closingTitle}</h3>
        <p className="zfooter__closing-text">{currentText.closing1}</p>
        <p className="zfooter__closing-text">{currentText.closing2}</p>
      </div>
    </footer>
  );
};

export default Footer;
